import { computed, ref, unref } from "vue";
import { chartDownloadFilename } from "./chartDownloadFilename";
import { downloadChartCardAsPng } from "./downloadChartCardAsPng";

export function useChartImageDownload({
  getRootElement,
  title,
  downloadContext,
  hasData,
}) {
  const isDownloading = ref(false);

  const canDownload = computed(() => Boolean(unref(hasData)));

  async function downloadImage() {
    const root = getRootElement?.();
    if (!root || !canDownload.value || isDownloading.value) return;

    isDownloading.value = true;
    try {
      const resolvedTitle =
        typeof title === "function" ? title() : unref(title);
      const resolvedContext =
        typeof downloadContext === "function"
          ? downloadContext()
          : unref(downloadContext);

      await downloadChartCardAsPng(root, {
        filename: chartDownloadFilename(resolvedTitle, resolvedContext),
      });
    } finally {
      isDownloading.value = false;
    }
  }

  return { downloadImage, isDownloading, canDownload };
}
